import * as React from "react"
import type { SVGProps } from "react"
const SvgCrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17 22.14v-3H7q-.82 0-1.41-.58A2 2 0 0 1 5 17.13v-10H2a1 1 0 0 1-.71-.28A1 1 0 0 1 1 6.14q0-.42.29-.71A1 1 0 0 1 2 5.14h3v-3q0-.42.29-.71A1 1 0 0 1 6 1.14a.97.97 0 0 1 1 1v15h15q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28h-3v3q0 .43-.29.72a1 1 0 0 1-.71.28 1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72m0-7v-8H9v-2h8q.83 0 1.41.59.6.6.59 1.41v8z" />
  </svg>
)
export default SvgCrop
